import { Input as InputBase, InputProps } from 'antd';
import { ControllerRenderProps } from 'react-hook-form';

interface IProps extends InputProps {
  field?: ControllerRenderProps<any, any>;
}
export const Input: React.FC<IProps> = ({ className, field, ...props }) => {
  return <InputBase className={className} {...field} {...props} />;
};
